/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartnerStationDtoTimeZoneRules } from './PartnerStationDtoTimeZoneRules';
import {
    PartnerStationDtoTimeZoneRulesFromJSON,
    PartnerStationDtoTimeZoneRulesFromJSONTyped,
    PartnerStationDtoTimeZoneRulesToJSON,
} from './PartnerStationDtoTimeZoneRules';

/**
 * 
 * @export
 * @interface PartnerStationDtoTimeZone
 */
export interface PartnerStationDtoTimeZone {
    /**
     * 
     * @type {string}
     * @memberof PartnerStationDtoTimeZone
     */
    id?: string;
    /**
     * 
     * @type {PartnerStationDtoTimeZoneRules}
     * @memberof PartnerStationDtoTimeZone
     */
    rules?: PartnerStationDtoTimeZoneRules;
}

/**
 * Check if a given object implements the PartnerStationDtoTimeZone interface.
 */
export function instanceOfPartnerStationDtoTimeZone(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PartnerStationDtoTimeZoneFromJSON(json: any): PartnerStationDtoTimeZone {
    return PartnerStationDtoTimeZoneFromJSONTyped(json, false);
}

export function PartnerStationDtoTimeZoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerStationDtoTimeZone {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'rules': !exists(json, 'rules') ? undefined : PartnerStationDtoTimeZoneRulesFromJSON(json['rules']),
    };
}

export function PartnerStationDtoTimeZoneToJSON(value?: PartnerStationDtoTimeZone | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'rules': PartnerStationDtoTimeZoneRulesToJSON(value.rules),
    };
}

